<template>
  <CFooter :fixed="false">
    <div>
      <a href="http://lme.com.hk" target="_blank">LME SYSTEM</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="#" target="_blank">LME Development team</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
